module.exports = __webpack_public_path__ + "static/media/icon-massEmailColored.396831d7.svg";